/**
 * Full-page editor mode configuration.
 * Used for standalone article/KB editing where the editor occupies the main content area.
 */
export const fullMode = {
  id: "full",

  layout: {
    showHeader: true,
    showTocSidebar: true,
    showMobileToolbar: true,
    showFloatingToolbar: true,
    showTableHandles: true,
    wrapperClassName: "notion-like-editor-wrapper",
    contentClassName: "notion-like-editor-content",
    layoutClassName: "notion-like-editor-layout",
  },

  editor: {
    editorClassName: "notion-like-editor",
    placeholder: "Start writing...",
  },

  toolbar: {
    showUndoRedo: true,
    showThemeToggle: true,
    showSourceMode: true,
    showFindReplace: true,
    showMarkdownImport: true,
    showMarkdownExport: true,
  },
}

export default fullMode
